import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v10.5A2.75 2.75 0 0 0 4.75 20h14.5A2.75 2.75 0 0 0 22 17.25V6.75A2.75 2.75 0 0 0 19.25 4zm15.722 2.486A1.25 1.25 0 0 0 19.25 5.5H4.75c-.6 0-1.1.422-1.222.986L12 11.98zM3.5 8.256v8.994c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V8.255l-8.092 5.25a.75.75 0 0 1-.816 0z",
    clipRule: "evenodd"
  }));
}
var IcMail = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMail));

export { IcMail as I };
